import React, { Component } from 'react';
import { Document ,Page} from 'react-pdf';
import store from 'store';

import Config from './Config';

class PdfReport extends Component {

  constructor(props){
    super(props);

    this.state = {
      url : ''
    };
  }

  componentDidMount(){

    let url = Config.SERVER_URL + Config.API_LAB_RESULT_FILE + '?token=' + store.get(Config.TOKEN) + '&TestCaseID=' + store.get(Config.RESULT_ID);
    window.location = url;

    //this.setState({url});

  }

  render() {

    return(
      <section>Redirecting...</section>
    );
  }


  // <div>
  //       <Document
  //           file={{url : this.state.url }}
  //           onLoadError={(error) => alert('Error while loading page! ' + error.message)}
  //       >
  //         <Page pageNumber={1} />
  //       </Document>
  //     </div>
}

export default PdfReport;



// WEBPACK FOOTER //
// ./src/components/PdfReport.js